export default {"src":"/_next/static/media/SS-point-uncheckin.9b2be7a7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};